export const conexion = {
    //URL Desarrollo
  url: 'https://api-gpu.grinpu.com/api/',
//   url: 'http://127.0.0.1:8000/api/',
  url_img: 'https://api-gpu.grinpu.com',
//   url_img: 'http://127.0.0.1:8000',
  }
